module.exports = __webpack_public_path__ + "fonts/dljk.2591b889.ttf";